import DrawerItem from "./DrawerItem";
import { Link } from "react-router-dom";

export default function Drawer({ items }) {
	return (
		<div className={"flex flex-col"}>
			<div className='drawer !h-fit !min-h-[78vh]'>
				{/* <Search/> */}
				<div className='spaceDrawer'></div>
				{items.map((item, i) => (
					<DrawerItem key={`drawer-item-${i}`} {...item} className='drawerItems' />
				))}
				<div className='spaceDrawer'></div>
			</div>
		</div>
	);
}
